import type { ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PERMISSIONS } from '@lms/shared-types';
import { CourseHero } from '@/components/courses/CourseHero';
import { CourseHubTabs } from '@/components/courses/CourseHubTabs';
import { courseBackUrl, studentHubBackUrl, type CourseHubTab } from '@/lib/course-admin-navigation';
import { usePermissions } from '@/hooks/usePermissions';

interface CourseHubShellProps {
  courseId: string;
  courseName: string;
  categoryId?: string | null;
  activeTab: CourseHubTab;
  description?: string | null;
  meta?: ReactNode;
  aside?: ReactNode;
  showProgress?: boolean;
  progressPercent?: number;
  studentHub?: boolean;
  children: ReactNode;
}

export function CourseHubShell({
  courseId,
  courseName,
  categoryId,
  activeTab,
  description,
  meta,
  aside,
  showProgress,
  progressPercent,
  studentHub = false,
  children,
}: CourseHubShellProps) {
  const [searchParams] = useSearchParams();
  const { hasPermission } = usePermissions();
  const backUrl =
    studentHub || (!hasPermission(PERMISSIONS.CURSOS_VER) && hasPermission(PERMISSIONS.MIS_CURSOS_VER))
      ? studentHubBackUrl(searchParams)
      : courseBackUrl(searchParams, categoryId);

  return (
    <div className="font-sans">
      <CourseHero
        title={courseName}
        backUrl={backUrl}
        description={description}
        meta={meta}
        aside={aside}
        showProgress={showProgress}
        progressPercent={progressPercent}
      />
      <div className="lms-course-hub-tabs-bar">
        <div className="lms-site-admin-hub-container">
          <CourseHubTabs courseId={courseId} active={activeTab} studentHub={studentHub} />
        </div>
      </div>
      <div className="lms-site-admin-hub-container py-8 md:py-10">{children}</div>
    </div>
  );
}
